import React from 'react'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {useIntl} from 'react-intl'

function ColorPalette({
  primaryColor,
  accentColor,
  setPrimaryColor,
  setAccentColor,
}: {
  primaryColor?: string
  accentColor?: string
  setPrimaryColor: any
  setAccentColor: any
}) {
  const {formatMessage} = useIntl()

  return (
    <div className='d-flex mt-5 gap-7' style={{borderRadius: '4px'}}>
      <div>
        <label
          className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
          htmlFor='kt_login_toc_agree'
        >
          {formatMessage({id: 'Primary Color'})}
          <ToolTipUI
            tooltipText={formatMessage({
              id: "Set your primary brand color. This will be used across the platform to match your company's brand identity.",
            })}
          />
        </label>
        <div className='d-flex'>
          <div
            style={{
              display: 'inline-block',
              width: '50px',
              height: '50px',
              backgroundColor: `${primaryColor}` || '#1f36dh',
              marginLeft: '0px',
              borderTopLeftRadius: '4px',
              borderBottomLeftRadius: '4px',
            }}
          ></div>
          <input
            type='text'
            value={primaryColor}
            onChange={(e) => setPrimaryColor(e.target.value)}
            style={{
              marginLeft: '0px',
              padding: '5px 0px 5px 20px',
              width: '100px',
              border: '1px solid #8898A666',
              borderTopRightRadius: '4px',
              borderBottomRightRadius: '4px',
              outline: 'none',
              lineHeight: '20px',
              fontSize: '13px',
            }}
          />
        </div>
      </div>
      <div>
        <label
          className='form-label font-size-13 mb-3  text-dark text-capitalize  ms-md-0  d-flex align-items-md-center  fw-normal mb-0 col-md-12'
          htmlFor='kt_login_toc_agree'
        >
          {formatMessage({id: 'Accent Color'})}
          <ToolTipUI
            tooltipText={formatMessage({
              id: 'Set your accent color. This color will be used to highlight key elements on the platform.',
            })}
          />
        </label>
        <div className='d-flex'>
          <div
            style={{
              display: 'inline-block',
              width: '50px',
              height: '50px',
              backgroundColor: accentColor || '#AF56112',
              marginLeft: '0px',
              borderTopLeftRadius: '4px',
              borderBottomLeftRadius: '4px',
            }}
          ></div>
          <input
            type='text'
            value={accentColor}
            onChange={(e) => setAccentColor(e.target.value)}
            style={{
              marginLeft: '0px',
              padding: '5px 0px 5px 20px',
              width: '100px',
              border: '1px solid #8898A666',
              borderTopRightRadius: '4px',
              borderBottomRightRadius: '4px',
              outline: 'none',
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ColorPalette
